import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { listCharterPricingInventory, upsertCharterPricingInventory } from '~/services/CharterPricingInventoryService';

import type {
  ListCharterPricingInventoryParams,
  UpsertCharterPricingInventoryBody,
} from '~/types/charterPricingInventory';

import { charterPricingInventoryQueryKeys } from './charterPricingInventoryQueryKeys';

export function useGetCharterPricingInventoryList(
  params: ListCharterPricingInventoryParams = {},
  options: { enabled?: boolean } = {},
) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: charterPricingInventoryQueryKeys.list(params),
    queryFn: async ({ signal }) => {
      return await listCharterPricingInventory(params, { signal });
    },
    enabled,
  });
}

export function useUpsertCharterPricingInventory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: UpsertCharterPricingInventoryBody) => {
      return await upsertCharterPricingInventory(body);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: charterPricingInventoryQueryKeys.all });
    },
  });
}
